import { Component, EventEmitter, Input, Output, ViewChildren, QueryList } from '@angular/core';

import { filtersAdvanced } from '@/app/interfaces/filtersAdvanced';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { MultiselectComponent } from '../multiselect/multiselect.component';
import { DesyAngularModule } from 'desy-angular';
import { ButtonsComponent } from '../buttons/buttons.component';

@Component({
  selector: 'app-filters',
  imports: [
    CommonModule,
    FormsModule,
    DatePickerComponent,
    DropdownComponent,
    MultiselectComponent,
    DesyAngularModule,
    ButtonsComponent,
  ],
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss',
  standalone: true,
})
export class FiltersComponent {
  private _filtersAdvanced: filtersAdvanced[] = [];
  @ViewChildren('filterRef') filterRefs!: QueryList<MultiselectComponent | DatePickerComponent>;
  @Input() title: string = 'Filtros Avanzados';
  @Input() set filtersAdvanced(value: filtersAdvanced[]) {
    this._filtersAdvanced = this.reorderFilters(value);
  }
  get filtersAdvanced() {
    return this._filtersAdvanced;
  }

  @Input() containerClass: string = 'grid grid-cols-4 items-end';

  @Output() applyFilters = new EventEmitter<filtersAdvanced[]>();

  showFilters = false;
  private reorderFilters(filters: filtersAdvanced[]): filtersAdvanced[] {
    const dateFilters = filters.filter((f) => f.type === 'dateRange');
    const otherFilters = filters.filter((f) => f.type !== 'dateRange');

    return [...otherFilters, ...dateFilters];
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onApplyFilters() {
    this.applyFilters.emit(this.filtersAdvanced);
  }

  onClearFilters(): void {
    this.filterRefs.forEach((ref) => {
      if (typeof ref.clearSelection === 'function') {
        ref.clearSelection();
      }
    });

    this.applyFilters.emit(this.filtersAdvanced);
  }

  onDropdownChange(i: number, value) {
    this.filtersAdvanced[i].selected = value;
  }

  onMultiselectChange(event: string[] | number[], i: number): void {
    this.filtersAdvanced[i].selected = null;
    if (event?.length) {
      (this.filtersAdvanced[i].selected as (string | number | number[] | string[])[]) = event;
    }
  }

  onRangeSelected(event: string | string[], i: number): void {
    this.filtersAdvanced[i].dateRangeOptions.startDate = null;
    this.filtersAdvanced[i].dateRangeOptions.endDate = null;
    let formatDates = [];
    if (Array.isArray(event)) {
      formatDates = event.map((fStr) => {
        const [d, m, a] = fStr.split('/').map(Number);
        return new Date(a, m - 1, d);
      });
    }

    if (formatDates[0]) {
      this.filtersAdvanced[i].dateRangeOptions.startDate = new Date(formatDates[0]);
    }
    if (formatDates[1]) {
      this.filtersAdvanced[i].dateRangeOptions.endDate = new Date(formatDates[1]);
    }
  }
}
